module.exports = __webpack_public_path__ + "img/trash-autoplay.3a7d9a84.svg";